<script lang="ts" setup>
defineProps<{
  width: number;
}>();
</script>

<template>
  <div class="flex h-1 w-full bg-slate-200">
    <div
      class="h-full bg-[var(--customer-background)]"
      :style="{
        width: width + '%',
      }"
    />
  </div>
</template>
